import React, { useState, useRef, useEffect } from "react";
import { FaBars, FaTimes, FaAngleDown } from "react-icons/fa";
import Button from "./Button";
import { useTheme } from "../context/ThemeContext";
import { Link } from "react-router-dom";

const NavBar = ({ isTransparent = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownContainerRef = useRef(null);
  // const location = useLocation();
  // const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleMobileDropdown = () => {
    setShowMobileDropdown(!showMobileDropdown);
  };

  return (
    <nav
      className={`w-full z-[100] ${
        isTransparent
          ? "absolute top-0 left-0 bg-transparent"
          : "bg-white dark:bg-[#000]"
      } font-lexend border-b border-[#333333]`}
    >
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-2">
        <div className="flex items-center justify-between h-[86px]">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              {/* <img
                src={
                  isDarkMode
                    ? "/assets/Lunor quest black.png"
                    : "/assets/Lunor quest white.png"
                }
                alt="Lunor Quest"
                className="w-[165px] h-[26px] transition-all duration-200"
                style={{ objectFit: "contain" }}
              /> */}
              {isDarkMode ? (
              <svg
                width="165"
                height="27"
                viewBox="0 0 165 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.6476 8.12086C25.972 9.18258 26.1469 10.3096 26.1469 11.4767C26.1469 17.8154 21.0089 22.9554 14.6681 22.9554C8.32731 22.9554 3.18936 17.8175 3.18936 11.4767C3.18936 5.13584 7.99237 0.341263 14.0404 0.0168498C13.8128 0.00631691 13.5853 0 13.3557 0C5.97848 0 0 5.98058 0 13.3557C0 20.7309 5.98058 26.7114 13.3557 26.7114C20.7309 26.7114 26.7114 20.7309 26.7114 13.3557C26.7114 11.4977 26.3322 9.72818 25.6455 8.12086H25.6476Z"
                  fill="#ADFF00"
                />
                <path
                  d="M15.8686 21.2175C10.9456 21.2175 6.9557 17.2276 6.9557 12.3046C6.9557 7.38149 10.9456 3.39163 15.8686 3.39163C20.7917 3.39163 24.7816 7.38149 24.7816 12.3046C24.7816 14.4069 24.0527 16.3387 22.8351 17.8638C24.3245 16.0669 25.2219 13.7623 25.2219 11.245C25.2219 5.51717 20.579 0.874268 14.8512 0.874268C9.12337 0.874268 4.48047 5.51717 4.48047 11.245C4.48047 16.9728 9.12337 21.6157 14.8512 21.6157C17.2169 21.6157 19.3951 20.8236 21.1393 19.4901C19.6626 20.575 17.8404 21.2154 15.8686 21.2154V21.2175Z"
                  fill="#FCD535"
                />
                <path
                  d="M20.2463 6.06682C19.865 5.80772 19.471 5.58864 19.0645 5.40747C19.0961 5.42854 19.1256 5.44749 19.1572 5.46856C22.2538 7.57514 23.0564 11.7946 20.9478 14.8913C18.8412 17.988 14.6217 18.7906 11.525 16.6819C9.52377 15.3189 8.48102 13.0754 8.56317 10.8214C7.97754 13.72 9.12774 16.8188 11.7251 18.5862C15.182 20.9393 19.8924 20.044 22.2454 16.5871C24.5985 13.1302 23.7032 8.41987 20.2463 6.06682Z"
                  fill="#5C25D2"
                />
                <path
                  d="M35.0368 17.276C35.0368 17.7416 35.0368 18.1544 35.062 18.5694C35.1147 19.3447 35.4749 19.6038 36.6925 19.5005V21.4913C36.1238 21.5692 35.477 21.6219 34.8303 21.6219C33.3304 21.6219 32.3214 21.0784 32.2182 19.3194C32.1929 18.8012 32.1929 18.1818 32.1929 17.3539V2.4541H35.0389V17.276H35.0368Z"
                  fill="white"
                />
                <path
                  d="M51.1329 21.3333H48.3143V18.9802L47.3579 20.6866C46.2709 21.4618 45.2618 21.6956 43.8926 21.6956C41.0466 21.6956 39.3929 20.0925 39.0811 18.2029C38.9779 17.5035 38.9526 16.8842 38.9526 15.7719V7.59839H41.7712V15.2031C41.7712 15.6434 41.7965 16.3934 41.8745 17.0906C42.0809 18.5905 43.0647 19.5743 44.8237 19.5743C46.8144 19.5743 48.3164 18.047 48.3164 14.0656V7.59839H51.135V21.3333H51.1329Z"
                  fill="white"
                />
                <path
                  d="M66.9871 13.598V21.3312H64.1411V13.9076C64.1411 13.2609 64.1411 12.6668 64.0884 11.9675C63.9599 10.4149 63.132 9.33002 61.1919 9.33002C59.2517 9.33002 57.6233 10.8826 57.6233 15.1758V21.3312H54.7773V7.59631H57.6233V9.87352L58.5544 8.29569C59.6414 7.46781 60.6505 7.23608 62.0198 7.23608C64.969 7.23608 66.65 8.76125 66.9091 11.167C66.9618 11.8642 66.9871 12.4857 66.9871 13.598Z"
                  fill="white"
                />
                <path
                  d="M83.334 14.451C83.334 18.4599 80.981 21.6935 76.376 21.6935C71.771 21.6935 69.418 18.4599 69.418 14.451C69.418 10.4422 71.7457 7.23389 76.376 7.23389C81.0063 7.23389 83.334 10.4422 83.334 14.451ZM80.309 14.451C80.309 11.348 78.8597 9.30255 76.3781 9.30255C73.8966 9.30255 72.4198 11.3459 72.4198 14.451C72.4198 17.5561 73.8692 19.6248 76.3781 19.6248C78.887 19.6248 80.309 17.5561 80.309 14.451Z"
                  fill="white"
                />
                <path
                  d="M92.9295 7.4172V9.64175C90.3173 9.46059 88.6868 10.8067 88.6868 14.1941V21.3333H85.8408V7.59837H88.6868V9.92614L89.8517 8.03865C90.4732 7.54781 91.2737 7.26343 91.9731 7.26343C92.3607 7.26343 92.6451 7.31609 92.9295 7.41931V7.4172Z"
                  fill="white"
                />
                <path
                  d="M112.119 26.6502H109.237V19.313L108.188 20.834C107.402 21.4638 105.961 21.883 104.546 21.883C100.562 21.883 98.2827 18.8685 98.2827 14.7818C98.2827 9.69859 101.428 7.23389 105.017 7.23389C106.17 7.23389 107.613 7.54777 108.318 8.09969L109.235 9.48793V7.60043H112.117V26.6523L112.119 26.6502ZM109.235 14.7017V13.9686C109.235 10.5876 107.191 9.32994 105.329 9.32994C103.05 9.32994 101.32 11.0847 101.32 14.5458C101.32 17.5603 102.709 19.787 105.199 19.787C107.375 19.787 109.235 18.424 109.235 14.7038V14.7017Z"
                  fill="#FCD535"
                />
                <path
                  d="M127.947 21.5143H125.091V19.1297L124.122 20.8592C123.02 21.6449 121.998 21.8808 120.61 21.8808C117.728 21.8808 116.049 20.2567 115.736 18.3439C115.63 17.6361 115.605 17.0083 115.605 15.8813V7.60034H118.462V15.3062C118.462 15.7507 118.487 16.5112 118.567 17.219C118.777 18.7399 119.772 19.7342 121.554 19.7342C123.572 19.7342 125.091 18.188 125.091 14.1518V7.60034H127.947V21.5164V21.5143Z"
                  fill="#FCD535"
                />
                <path
                  d="M143.566 15.3568H133.581C133.816 18.6852 135.335 19.7848 137.223 19.7848C138.9 19.7848 140.21 18.7631 140.499 17.0062H143.408C142.805 20.3072 140.157 21.8808 137.117 21.8808C133.395 21.8808 130.591 19.5215 130.591 14.5963C130.591 10.1935 133.395 7.23169 137.406 7.23169C141.417 7.23169 143.616 10.2715 143.616 14.2024C143.616 14.4636 143.616 14.8575 143.564 15.3547L143.566 15.3568ZM133.608 13.3387H140.657C140.446 10.7707 139.321 9.32985 137.303 9.32985C135.285 9.32985 133.922 10.6654 133.608 13.3387Z"
                  fill="#FCD535"
                />
                <path
                  d="M156.144 11.5818H153.21C152.921 10.1135 152.057 9.2498 150.642 9.2498C149.226 9.2498 148.624 10.0103 148.624 11.0572C148.624 12.3149 149.645 12.8394 151.716 13.3892C154.756 14.175 156.355 15.3799 156.355 17.8446C156.355 20.5432 153.97 21.8808 150.93 21.8808C147.89 21.8808 145.558 20.4926 145.165 17.3475H148.074C148.415 19.1297 149.595 19.8375 151.036 19.8375C152.371 19.8375 153.446 19.2603 153.446 18.0553C153.446 16.8503 152.502 16.1952 150.145 15.5653C147.602 14.9102 145.716 13.8358 145.716 11.3985C145.716 8.8032 147.76 7.23169 150.852 7.23169C153.945 7.23169 155.832 9.03914 156.146 11.5818H156.144Z"
                  fill="#FCD535"
                />
                <path
                  d="M162.276 17.0063C162.276 17.4782 162.276 17.7921 162.301 18.1586C162.407 19.5216 162.931 19.8102 164.817 19.6269V21.6197C164.084 21.725 163.401 21.7777 162.693 21.7777C160.517 21.7777 159.576 20.9646 159.443 19.1297C159.418 18.6579 159.418 18.0554 159.418 17.2696V9.72175H157.452V7.70364H159.418V4.37524H162.274V7.70364H165V9.72175H162.274V17.0063H162.276Z"
                  fill="#FCD535"
                />
              </svg>
              ) : (
              <svg
                width="165"
                height="27"
                viewBox="0 0 165 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.6476 8.12086C25.972 9.18258 26.1469 10.3096 26.1469 11.4767C26.1469 17.8154 21.0089 22.9554 14.6681 22.9554C8.32731 22.9554 3.18936 17.8175 3.18936 11.4767C3.18936 5.13584 7.99237 0.341263 14.0404 0.0168498C13.8128 0.00631691 13.5853 0 13.3557 0C5.97848 0 0 5.98058 0 13.3557C0 20.7309 5.98058 26.7114 13.3557 26.7114C20.7309 26.7114 26.7114 20.7309 26.7114 13.3557C26.7114 11.4977 26.3322 9.72818 25.6455 8.12086H25.6476Z"
                  fill="#ADFF00"
                />
                <path
                  d="M15.8689 21.2175C10.9458 21.2175 6.95594 17.2276 6.95594 12.3046C6.95594 7.3815 10.9458 3.39163 15.8689 3.39163C20.792 3.39163 24.7818 7.3815 24.7818 12.3046C24.7818 14.4069 24.0529 16.3387 22.8353 17.8638C24.3247 16.0669 25.2221 13.7623 25.2221 11.245C25.2221 5.51717 20.5792 0.874268 14.8514 0.874268C9.12361 0.874268 4.48071 5.51717 4.48071 11.245C4.48071 16.9728 9.12361 21.6157 14.8514 21.6157C17.2171 21.6157 19.3953 20.8236 21.1395 19.4901C19.6628 20.575 17.8406 21.2154 15.8689 21.2154V21.2175Z"
                  fill="#EABE00"
                />
                <path
                  d="M20.2464 6.06682C19.8651 5.80772 19.4712 5.58864 19.0646 5.40747C19.0962 5.42854 19.1257 5.44749 19.1573 5.46856C22.254 7.57514 23.0566 11.7946 20.9479 14.8913C18.8413 17.988 14.6218 18.7906 11.5251 16.6819C9.5239 15.3189 8.48114 13.0754 8.5633 10.8214C7.97767 13.72 9.12786 16.8188 11.7253 18.5862C15.1822 20.9393 19.8925 20.044 22.2455 16.5871C24.5986 13.1302 23.7033 8.41987 20.2464 6.06682Z"
                  fill="#5C25D2"
                />
                <path
                  d="M35.0366 17.276C35.0366 17.7416 35.0366 18.1544 35.0619 18.5694C35.1146 19.3447 35.4748 19.6038 36.6924 19.5005V21.4913C36.1236 21.5692 35.4769 21.6219 34.8302 21.6219C33.3303 21.6219 32.3213 21.0784 32.218 19.3194C32.1928 18.8012 32.1927 18.1818 32.1927 17.3539V2.4541H35.0387V17.276H35.0366Z"
                  fill="black"
                />
                <path
                  d="M51.133 21.3333H48.3144V18.9802L47.358 20.6866C46.271 21.4618 45.262 21.6956 43.8927 21.6956C41.0467 21.6956 39.393 20.0925 39.0813 18.2029C38.978 17.5035 38.9528 16.8842 38.9528 15.7719V7.59839H41.7714V15.2031C41.7714 15.6434 41.7966 16.3934 41.8746 17.0906C42.081 18.5905 43.0648 19.5743 44.8238 19.5743C46.8145 19.5743 48.3165 18.047 48.3165 14.0656V7.59839H51.1351V21.3333H51.133Z"
                  fill="black"
                />
                <path
                  d="M66.9871 13.598V21.3312H64.1411V13.9076C64.1411 13.2609 64.1411 12.6668 64.0884 11.9675C63.9599 10.4149 63.132 9.33002 61.1919 9.33002C59.2517 9.33002 57.6233 10.8826 57.6233 15.1758V21.3312H54.7773V7.59631H57.6233V9.87352L58.5544 8.29569C59.6414 7.46781 60.6505 7.23608 62.0198 7.23608C64.969 7.23608 66.65 8.76125 66.9091 11.167C66.9618 11.8642 66.9871 12.4857 66.9871 13.598Z"
                  fill="black"
                />
                <path
                  d="M83.3342 14.451C83.3342 18.4599 80.9811 21.6935 76.3761 21.6935C71.7711 21.6935 69.4181 18.4599 69.4181 14.451C69.4181 10.4422 71.7459 7.23389 76.3761 7.23389C81.0064 7.23389 83.3342 10.4422 83.3342 14.451ZM80.3091 14.451C80.3091 11.348 78.8598 9.30255 76.3782 9.30255C73.8967 9.30255 72.42 11.3459 72.42 14.451C72.42 17.5561 73.8693 19.6248 76.3782 19.6248C78.8872 19.6248 80.3091 17.5561 80.3091 14.451Z"
                  fill="black"
                />
                <path
                  d="M92.9297 7.4172V9.64175C90.3176 9.46059 88.6871 10.8067 88.6871 14.1941V21.3333H85.8411V7.59837H88.6871V9.92614L89.852 8.03865C90.4734 7.54781 91.2739 7.26343 91.9733 7.26343C92.3609 7.26343 92.6453 7.31609 92.9297 7.41931V7.4172Z"
                  fill="black"
                />
                <path
                  d="M112.118 26.6502H109.237V19.313L108.188 20.834C107.402 21.4638 105.961 21.883 104.545 21.883C100.562 21.883 98.2825 18.8685 98.2825 14.7818C98.2825 9.69859 101.428 7.23389 105.017 7.23389C106.17 7.23389 107.613 7.54777 108.318 8.09969L109.235 9.48793V7.60043H112.116V26.6523L112.118 26.6502ZM109.235 14.7017V13.9686C109.235 10.5876 107.191 9.32994 105.329 9.32994C103.05 9.32994 101.32 11.0847 101.32 14.5458C101.32 17.5603 102.708 19.787 105.198 19.787C107.374 19.787 109.235 18.424 109.235 14.7038V14.7017Z"
                  fill="#EABE00"
                />
                <path
                  d="M127.947 21.5143H125.091V19.1297L124.122 20.8592C123.02 21.6449 121.998 21.8808 120.61 21.8808C117.728 21.8808 116.049 20.2567 115.735 18.3439C115.63 17.6361 115.605 17.0083 115.605 15.8813V7.60034H118.461V15.3062C118.461 15.7507 118.487 16.5112 118.567 17.219C118.777 18.7399 119.772 19.7342 121.554 19.7342C123.572 19.7342 125.091 18.188 125.091 14.1518V7.60034H127.947V21.5164V21.5143Z"
                  fill="#EABE00"
                />
                <path
                  d="M143.565 15.3568H133.58C133.816 18.6852 135.335 19.7848 137.223 19.7848C138.899 19.7848 140.21 18.7631 140.498 17.0062H143.408C142.805 20.3072 140.157 21.8808 137.117 21.8808C133.395 21.8808 130.591 19.5215 130.591 14.5963C130.591 10.1935 133.395 7.23169 137.406 7.23169C141.417 7.23169 143.616 10.2715 143.616 14.2024C143.616 14.4636 143.616 14.8575 143.563 15.3547L143.565 15.3568ZM133.608 13.3387H140.656C140.446 10.7707 139.321 9.32985 137.303 9.32985C135.285 9.32985 133.922 10.6654 133.608 13.3387Z"
                  fill="#EABE00"
                />
                <path
                  d="M156.144 11.5818H153.209C152.921 10.1135 152.057 9.2498 150.642 9.2498C149.226 9.2498 148.623 10.0103 148.623 11.0572C148.623 12.3149 149.645 12.8394 151.716 13.3892C154.756 14.175 156.355 15.3799 156.355 17.8446C156.355 20.5432 153.97 21.8808 150.93 21.8808C147.89 21.8808 145.558 20.4926 145.164 17.3475H148.074C148.415 19.1297 149.595 19.8375 151.035 19.8375C152.371 19.8375 153.445 19.2603 153.445 18.0553C153.445 16.8503 152.502 16.1952 150.144 15.5653C147.602 14.9102 145.716 13.8358 145.716 11.3985C145.716 8.8032 147.76 7.23169 150.852 7.23169C153.945 7.23169 155.832 9.03914 156.146 11.5818H156.144Z"
                  fill="#EABE00"
                />
                <path
                  d="M162.276 17.0063C162.276 17.4782 162.276 17.7921 162.301 18.1586C162.407 19.5216 162.931 19.8102 164.817 19.6269V21.6197C164.084 21.725 163.401 21.7777 162.693 21.7777C160.517 21.7777 159.575 20.9646 159.443 19.1297C159.417 18.6579 159.417 18.0554 159.417 17.2696V9.72175H157.452V7.70364H159.417V4.37524H162.274V7.70364H165V9.72175H162.274V17.0063H162.276Z"
                  fill="#EABE00"
                />
              </svg>
              )}
            </Link>
          </div>

          {/* Right Side Menu Items */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Launch Quest Dropdown */}
            <div
              className="relative h-[86px] flex items-center"
              ref={dropdownContainerRef}
            >
              <button
                ref={buttonRef}
                onClick={toggleDropdown}
                className={`flex items-center space-x-1 ${
                  isDarkMode
                    ? "text-white hover:text-[#FCD535]"
                    : "text-black hover:text-[#FCD535]"
                } transition-colors bg-transparent`}
              >
                <span>Launch Quest</span>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`transition-transform duration-200 ${
                    showDropdown ? "rotate-180" : ""
                  }`}
                >
                  <path
                    d="M1 1.5L6 6.5L11 1.5"
                    stroke="currentColor"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {/* Dropdown Menu */}
              {showDropdown && (
                <div
                  ref={dropdownRef}
                  className="absolute top-[70px] -left-2 w-56 rounded-lg shadow-lg bg-[#fff] dark:bg-[#000] border border-[#333333] overflow-hidden z-[100]"
                >
                  <div className="py-2">
                    <Link
                      to="/individuals"
                      className="block px-4 py-2 text-black dark:text-white hover:font-medium transition-all flex items-center space-x-2"
                      onClick={() => setShowDropdown(false)}
                    >
                      <svg
                        width="15"
                        height="19"
                        viewBox="0 0 15 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.62532 9.16666C8.53182 9.16666 9.41796 8.89786 10.1717 8.39423C10.9254 7.89061 11.5129 7.17479 11.8598 6.3373C12.2067 5.4998 12.2974 4.57825 12.1206 3.68917C11.9437 2.80009 11.5072 1.98342 10.8662 1.34243C10.2252 0.701438 9.40857 0.264918 8.51949 0.0880695C7.63041 -0.0887794 6.70885 0.00198589 5.87136 0.348887C5.03386 0.695789 4.31805 1.28325 3.81442 2.03697C3.3108 2.7907 3.04199 3.67684 3.04199 4.58333C3.04321 5.79854 3.52648 6.96362 4.38576 7.8229C5.24504 8.68218 6.41012 9.16545 7.62532 9.16666ZM7.62532 1.52778C8.22965 1.52778 8.82041 1.70698 9.3229 2.04273C9.82538 2.37848 10.217 2.85569 10.4483 3.41402C10.6796 3.97235 10.7401 4.58672 10.6222 5.17944C10.5043 5.77216 10.2133 6.31661 9.78593 6.74394C9.3586 7.17126 8.81415 7.46228 8.22143 7.58018C7.62871 7.69807 7.01434 7.63756 6.45601 7.4063C5.89768 7.17503 5.42047 6.78339 5.08472 6.28091C4.74897 5.77842 4.56977 5.18766 4.56977 4.58333C4.56977 3.77295 4.89169 2.99576 5.46472 2.42273C6.03775 1.8497 6.81494 1.52778 7.62532 1.52778Z"
                          fill="url(#paint0_linear_1137_1593)"
                        />
                        <path
                          d="M7.625 10.6941C5.80225 10.6961 4.05475 11.4211 2.76587 12.71C1.477 13.9988 0.752022 15.7463 0.75 17.5691C0.75 17.7717 0.830481 17.966 0.973738 18.1092C1.11699 18.2525 1.31129 18.333 1.51389 18.333C1.71648 18.333 1.91078 18.2525 2.05404 18.1092C2.1973 17.966 2.27778 17.7717 2.27778 17.5691C2.27778 16.1509 2.84114 14.7908 3.84394 13.788C4.84674 12.7852 6.20683 12.2219 7.625 12.2219C9.04317 12.2219 10.4033 12.7852 11.4061 13.788C12.4088 14.7908 12.9722 16.1509 12.9722 17.5691C12.9722 17.7717 13.0527 17.966 13.196 18.1092C13.3392 18.2525 13.5335 18.333 13.7361 18.333C13.9387 18.333 14.133 18.2525 14.2763 18.1092C14.4195 17.966 14.5 17.7717 14.5 17.5691C14.498 15.7463 13.773 13.9988 12.4841 12.71C11.1952 11.4211 9.44774 10.6961 7.625 10.6941Z"
                          fill="url(#paint1_linear_1137_1593)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1137_1593"
                            x1="12.2087"
                            y1="9.16666"
                            x2="2.04983"
                            y2="7.65269"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FCD535" />
                            <stop offset="1" stopColor="#F49097" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_1137_1593"
                            x1="14.5"
                            y1="18.333"
                            x2="-0.0310253"
                            y2="14.435"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FCD535" />
                            <stop offset="1" stopColor="#F49097" />
                          </linearGradient>
                        </defs>
                      </svg>

                      <span>For Individuals</span>
                    </Link>
                    <Link
                      to="/organisation"
                      className="block px-4 py-2 text-black dark:text-white hover:font-medium transition-all flex items-center space-x-2"
                      onClick={() => setShowDropdown(false)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.4998 8.9998V3.74992C10.4998 2.50944 9.49029 1.49997 8.24981 1.49997H3.74992C2.50944 1.49997 1.49997 2.50944 1.49997 3.74992V14.2497C1.49997 15.4902 2.50944 16.4996 3.74992 16.4996H8.24981C8.66456 16.4996 8.9998 16.8349 8.9998 17.2496C8.9998 17.6644 8.66456 17.9996 8.24981 17.9996H3.74992C1.68221 17.9996 0 16.3174 0 14.2497V3.74992C0 1.68221 1.68221 0 3.74992 0H8.24981C10.3175 0 11.9997 1.68221 11.9997 3.74992V8.9998C11.9997 9.41454 11.6645 9.74978 11.2497 9.74978C10.835 9.74978 10.4998 9.41454 10.4998 8.9998ZM4.4999 9.74978H3.74992C3.33518 9.74978 2.99993 10.085 2.99993 10.4998C2.99993 10.9145 3.33518 11.2497 3.74992 11.2497H4.4999C4.91464 11.2497 5.24988 10.9145 5.24988 10.4998C5.24988 10.085 4.91464 9.74978 4.4999 9.74978ZM8.24981 9.74978H7.49983C7.08509 9.74978 6.74985 10.085 6.74985 10.4998C6.74985 10.9145 7.08509 11.2497 7.49983 11.2497H8.24981C8.66456 11.2497 8.9998 10.9145 8.9998 10.4998C8.9998 10.085 8.66456 9.74978 8.24981 9.74978ZM4.4999 12.7497H3.74992C3.33518 12.7497 2.99993 13.085 2.99993 13.4997C2.99993 13.9144 3.33518 14.2497 3.74992 14.2497H4.4999C4.91464 14.2497 5.24988 13.9144 5.24988 13.4997C5.24988 13.085 4.91464 12.7497 4.4999 12.7497ZM8.24981 12.7497H7.49983C7.08509 12.7497 6.74985 13.085 6.74985 13.4997C6.74985 13.9144 7.08509 14.2497 7.49983 14.2497H8.24981C8.66456 14.2497 8.9998 13.9144 8.9998 13.4997C8.9998 13.085 8.66456 12.7497 8.24981 12.7497ZM4.4999 3.74992H3.74992C3.33518 3.74992 2.99993 4.08516 2.99993 4.4999C2.99993 4.91464 3.33518 5.24988 3.74992 5.24988H4.4999C4.91464 5.24988 5.24988 4.91464 5.24988 4.4999C5.24988 4.08516 4.91464 3.74992 4.4999 3.74992ZM8.24981 3.74992H7.49983C7.08509 3.74992 6.74985 4.08516 6.74985 4.4999C6.74985 4.91464 7.08509 5.24988 7.49983 5.24988H8.24981C8.66456 5.24988 8.9998 4.91464 8.9998 4.4999C8.9998 4.08516 8.66456 3.74992 8.24981 3.74992ZM4.4999 6.74985H3.74992C3.33518 6.74985 2.99993 7.08509 2.99993 7.49983C2.99993 7.91457 3.33518 8.24981 3.74992 8.24981H4.4999C4.91464 8.24981 5.24988 7.91457 5.24988 7.49983C5.24988 7.08509 4.91464 6.74985 4.4999 6.74985ZM8.24981 6.74985H7.49983C7.08509 6.74985 6.74985 7.08509 6.74985 7.49983C6.74985 7.91457 7.08509 8.24981 7.49983 8.24981H8.24981C8.66456 8.24981 8.9998 7.91457 8.9998 7.49983C8.9998 7.08509 8.66456 6.74985 8.24981 6.74985ZM17.9763 17.0629C17.5564 15.4324 15.9896 14.2497 14.2497 14.2497C12.5097 14.2497 10.943 15.4324 10.523 17.0629C10.4195 17.4634 10.6618 17.8728 11.063 17.9763C11.4605 18.0791 11.873 17.8376 11.9765 17.4364C12.224 16.4749 13.2012 15.7496 14.2497 15.7496C15.2982 15.7496 16.2754 16.4749 16.5229 17.4364C16.6099 17.7746 16.9144 17.9996 17.2489 17.9996C17.3111 17.9996 17.3741 17.9921 17.4364 17.9763C17.8376 17.8728 18.0791 17.4634 17.9763 17.0629ZM14.2497 13.4997C15.2839 13.4997 16.1246 12.659 16.1246 11.6247C16.1246 10.5905 15.2839 9.74978 14.2497 9.74978C13.2155 9.74978 12.3747 10.5905 12.3747 11.6247C12.3747 12.659 13.2155 13.4997 14.2497 13.4997Z"
                          fill="url(#paint0_linear_1137_1590)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1137_1590"
                            x1="18"
                            y1="18"
                            x2="-1.94825"
                            y2="15.0271"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FCD535" />
                            <stop offset="1" stopColor="#F49097" />
                          </linearGradient>
                        </defs>
                      </svg>

                      <span>For Organizations</span>
                    </Link>
                  </div>
                </div>
              )}
            </div>

            {/* Get Started Button */}
            <Button
              text="Get Started"
              link="https://app.lunor.quest/"
              size="small"
              onClick={() => {}}
              className="gradient"
            />

            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className={`transition-colors p-2 ${
                isDarkMode
                  ? "text-[#fff] hover:text-[#FCD535]"
                  : "text-[#000] hover:text-[#FCD535]"
              }`}
              aria-label="Toggle theme"
            >
              {isDarkMode ? (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5 27C22.7467 27 27 22.7467 27 17.5C27 12.2533 22.7467 8 17.5 8C12.2533 8 8 12.2533 8 17.5C8 22.7467 12.2533 27 17.5 27Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28.4767 28.4767L28.2759 28.2759M28.2759 6.61874L28.4767 6.41793L28.2759 6.61874ZM6.41793 28.4767L6.61874 28.2759L6.41793 28.4767ZM17.4473 2.12358V2V2.12358ZM17.4473 32.8946V32.771V32.8946ZM2.12358 17.4473H2H2.12358ZM32.8946 17.4473H32.771H32.8946ZM6.61874 6.61874L6.41793 6.41793L6.61874 6.61874Z"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.9127 14.2214C23.5537 14.7028 22.091 14.9647 20.5671 14.9647C13.3808 14.9647 7.5551 9.13907 7.5551 1.95276C7.5551 1.28906 7.60479 0.636971 7.70065 0C3.17585 1.90925 0 6.38717 0 11.6068C0 18.5613 5.63773 24.1991 12.5922 24.1991C18.6502 24.1991 23.7091 19.9211 24.9127 14.2214Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <button
              onClick={toggleTheme}
              className={`transition-colors p-2 ${
                isDarkMode
                  ? "text-[#fff] hover:text-[#FCD535]"
                  : "text-[#000] hover:text-[#FCD535]"
              }`}
              aria-label="Toggle theme"
            >
              {isDarkMode ? (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5 27C22.7467 27 27 22.7467 27 17.5C27 12.2533 22.7467 8 17.5 8C12.2533 8 8 12.2533 8 17.5C8 22.7467 12.2533 27 17.5 27Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28.4767 28.4767L28.2759 28.2759M28.2759 6.61874L28.4767 6.41793L28.2759 6.61874ZM6.41793 28.4767L6.61874 28.2759L6.41793 28.4767ZM17.4473 2.12358V2V2.12358ZM17.4473 32.8946V32.771V32.8946ZM2.12358 17.4473H2H2.12358ZM32.8946 17.4473H32.771H32.8946ZM6.61874 6.61874L6.41793 6.41793L6.61874 6.61874Z"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.9127 14.2214C23.5537 14.7028 22.091 14.9647 20.5671 14.9647C13.3808 14.9647 7.5551 9.13907 7.5551 1.95276C7.5551 1.28906 7.60479 0.636971 7.70065 0C3.17585 1.90925 0 6.38717 0 11.6068C0 18.5613 5.63773 24.1991 12.5922 24.1991C18.6502 24.1991 23.7091 19.9211 24.9127 14.2214Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>

            {/* Hamburger menu button */}
            <button
              onClick={toggleMenu}
              className={`${
                isDarkMode ? "text-[#fff]" : "text-[#000]"
              } hover:text-[#FCD535]`}
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute top-[86px] left-0 right-0 z-[100]">
            <div
              className="px-2 pt-10 pb-10 sm:px-3 bg-white dark:bg-black 
              shadow-lg rounded-lg mt-2
              border border-gray-100 dark:border-gray-800"
            >
              <div className="flex flex-row items-center justify-around">
                {/* Launch Quest Dropdown in Mobile */}
                <div className="relative">
                  <button
                    onClick={toggleMobileDropdown}
                    className={`flex items-center ${
                      isDarkMode
                        ? "text-white hover:text-[#FCD535]"
                        : "text-black hover:text-[#FCD535]"
                    } transition-colors bg-transparent`}
                  >
                    Launch Quest
                    <FaAngleDown
                      className={`ml-2 transition-transform ${
                        showMobileDropdown ? "rotate-180" : ""
                      }`}
                      size={16}
                    />
                  </button>

                  {showMobileDropdown && (
                    <div
                      className="absolute left-0 mt-2 w-56 bg-white dark:bg-black rounded-lg py-2 
                      border border-gray-100 dark:border-gray-800
                      shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06)]
                      dark:shadow-[0_4px_6px_-1px_rgba(0,0,0,0.4),0_2px_4px_-1px_rgba(0,0,0,0.2)]
                      z-[100]"
                    >
                      <Link
                        to="/individuals"
                        className="block px-4 py-2 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-900 flex gap-2 transition-colors"
                        onClick={() => {
                          setIsOpen(false);
                          setShowMobileDropdown(false);
                        }}
                      >
                        <svg
                          width="15"
                          height="19"
                          viewBox="0 0 15 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.62532 9.16666C8.53182 9.16666 9.41796 8.89786 10.1717 8.39423C10.9254 7.89061 11.5129 7.17479 11.8598 6.3373C12.2067 5.4998 12.2974 4.57825 12.1206 3.68917C11.9437 2.80009 11.5072 1.98342 10.8662 1.34243C10.2252 0.701438 9.40857 0.264918 8.51949 0.0880695C7.63041 -0.0887794 6.70885 0.00198589 5.87136 0.348887C5.03386 0.695789 4.31805 1.28325 3.81442 2.03697C3.3108 2.7907 3.04199 3.67684 3.04199 4.58333C3.04321 5.79854 3.52648 6.96362 4.38576 7.8229C5.24504 8.68218 6.41012 9.16545 7.62532 9.16666ZM7.62532 1.52778C8.22965 1.52778 8.82041 1.70698 9.3229 2.04273C9.82538 2.37848 10.217 2.85569 10.4483 3.41402C10.6796 3.97235 10.7401 4.58672 10.6222 5.17944C10.5043 5.77216 10.2133 6.31661 9.78593 6.74394C9.3586 7.17126 8.81415 7.46228 8.22143 7.58018C7.62871 7.69807 7.01434 7.63756 6.45601 7.4063C5.89768 7.17503 5.42047 6.78339 5.08472 6.28091C4.74897 5.77842 4.56977 5.18766 4.56977 4.58333C4.56977 3.77295 4.89169 2.99576 5.46472 2.42273C6.03775 1.8497 6.81494 1.52778 7.62532 1.52778Z"
                            fill="url(#paint0_linear_1137_1593)"
                          />
                          <path
                            d="M7.625 10.6941C5.80225 10.6961 4.05475 11.4211 2.76587 12.71C1.477 13.9988 0.752022 15.7463 0.75 17.5691C0.75 17.7717 0.830481 17.966 0.973738 18.1092C1.11699 18.2525 1.31129 18.333 1.51389 18.333C1.71648 18.333 1.91078 18.2525 2.05404 18.1092C2.1973 17.966 2.27778 17.7717 2.27778 17.5691C2.27778 16.1509 2.84114 14.7908 3.84394 13.788C4.84674 12.7852 6.20683 12.2219 7.625 12.2219C9.04317 12.2219 10.4033 12.7852 11.4061 13.788C12.4088 14.7908 12.9722 16.1509 12.9722 17.5691C12.9722 17.7717 13.0527 17.966 13.196 18.1092C13.3392 18.2525 13.5335 18.333 13.7361 18.333C13.9387 18.333 14.133 18.2525 14.2763 18.1092C14.4195 17.966 14.5 17.7717 14.5 17.5691C14.498 15.7463 13.773 13.9988 12.4841 12.71C11.1952 11.4211 9.44774 10.6961 7.625 10.6941Z"
                            fill="url(#paint1_linear_1137_1593)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1137_1593"
                              x1="12.2087"
                              y1="9.16666"
                              x2="2.04983"
                              y2="7.65269"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FCD535" />
                              <stop offset="1" stopColor="#F49097" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1137_1593"
                              x1="14.5"
                              y1="18.333"
                              x2="-0.0310253"
                              y2="14.435"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FCD535" />
                              <stop offset="1" stopColor="#F49097" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span> For Individuals</span>
                      </Link>
                      <Link
                        to="/organisation"
                        className="block px-4 py-2 text-gray-900 hover:bg-gray-100 dark:text-white flex gap-2 dark:hover:bg-gray-900 transition-colors"
                        onClick={() => {
                          setIsOpen(false);
                          setShowMobileDropdown(false);
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.4998 8.9998V3.74992C10.4998 2.50944 9.49029 1.49997 8.24981 1.49997H3.74992C2.50944 1.49997 1.49997 2.50944 1.49997 3.74992V14.2497C1.49997 15.4902 2.50944 16.4996 3.74992 16.4996H8.24981C8.66456 16.4996 8.9998 16.8349 8.9998 17.2496C8.9998 17.6644 8.66456 17.9996 8.24981 17.9996H3.74992C1.68221 17.9996 0 16.3174 0 14.2497V3.74992C0 1.68221 1.68221 0 3.74992 0H8.24981C10.3175 0 11.9997 1.68221 11.9997 3.74992V8.9998C11.9997 9.41454 11.6645 9.74978 11.2497 9.74978C10.835 9.74978 10.4998 9.41454 10.4998 8.9998ZM4.4999 9.74978H3.74992C3.33518 9.74978 2.99993 10.085 2.99993 10.4998C2.99993 10.9145 3.33518 11.2497 3.74992 11.2497H4.4999C4.91464 11.2497 5.24988 10.9145 5.24988 10.4998C5.24988 10.085 4.91464 9.74978 4.4999 9.74978ZM8.24981 9.74978H7.49983C7.08509 9.74978 6.74985 10.085 6.74985 10.4998C6.74985 10.9145 7.08509 11.2497 7.49983 11.2497H8.24981C8.66456 11.2497 8.9998 10.9145 8.9998 10.4998C8.9998 10.085 8.66456 9.74978 8.24981 9.74978ZM4.4999 12.7497H3.74992C3.33518 12.7497 2.99993 13.085 2.99993 13.4997C2.99993 13.9144 3.33518 14.2497 3.74992 14.2497H4.4999C4.91464 14.2497 5.24988 13.9144 5.24988 13.4997C5.24988 13.085 4.91464 12.7497 4.4999 12.7497ZM8.24981 12.7497H7.49983C7.08509 12.7497 6.74985 13.085 6.74985 13.4997C6.74985 13.9144 7.08509 14.2497 7.49983 14.2497H8.24981C8.66456 14.2497 8.9998 13.9144 8.9998 13.4997C8.9998 13.085 8.66456 12.7497 8.24981 12.7497ZM4.4999 3.74992H3.74992C3.33518 3.74992 2.99993 4.08516 2.99993 4.4999C2.99993 4.91464 3.33518 5.24988 3.74992 5.24988H4.4999C4.91464 5.24988 5.24988 4.91464 5.24988 4.4999C5.24988 4.08516 4.91464 3.74992 4.4999 3.74992ZM8.24981 3.74992H7.49983C7.08509 3.74992 6.74985 4.08516 6.74985 4.4999C6.74985 4.91464 7.08509 5.24988 7.49983 5.24988H8.24981C8.66456 5.24988 8.9998 4.91464 8.9998 4.4999C8.9998 4.08516 8.66456 3.74992 8.24981 3.74992ZM4.4999 6.74985H3.74992C3.33518 6.74985 2.99993 7.08509 2.99993 7.49983C2.99993 7.91457 3.33518 8.24981 3.74992 8.24981H4.4999C4.91464 8.24981 5.24988 7.91457 5.24988 7.49983C5.24988 7.08509 4.91464 6.74985 4.4999 6.74985ZM8.24981 6.74985H7.49983C7.08509 6.74985 6.74985 7.08509 6.74985 7.49983C6.74985 7.91457 7.08509 8.24981 7.49983 8.24981H8.24981C8.66456 8.24981 8.9998 7.91457 8.9998 7.49983C8.9998 7.08509 8.66456 6.74985 8.24981 6.74985ZM17.9763 17.0629C17.5564 15.4324 15.9896 14.2497 14.2497 14.2497C12.5097 14.2497 10.943 15.4324 10.523 17.0629C10.4195 17.4634 10.6618 17.8728 11.063 17.9763C11.4605 18.0791 11.873 17.8376 11.9765 17.4364C12.224 16.4749 13.2012 15.7496 14.2497 15.7496C15.2982 15.7496 16.2754 16.4749 16.5229 17.4364C16.6099 17.7746 16.9144 17.9996 17.2489 17.9996C17.3111 17.9996 17.3741 17.9921 17.4364 17.9763C17.8376 17.8728 18.0791 17.4634 17.9763 17.0629ZM14.2497 13.4997C15.2839 13.4997 16.1246 12.659 16.1246 11.6247C16.1246 10.5905 15.2839 9.74978 14.2497 9.74978C13.2155 9.74978 12.3747 10.5905 12.3747 11.6247C12.3747 12.659 13.2155 13.4997 14.2497 13.4997Z"
                            fill="url(#paint0_linear_1137_1590)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1137_1590"
                              x1="18"
                              y1="18"
                              x2="-1.94825"
                              y2="15.0271"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FCD535" />
                              <stop offset="1" stopColor="#F49097" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span> For Organisation</span>
                      </Link>
                    </div>
                  )}
                </div>

                <Button
                  text="Get Started"
                  link="#"
                  size="small"
                  className="mx-2"
                  onClick={() => setIsOpen(false)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
